import React from "react";

const Error = ({ error }) => {
  return <div className="warning-div">{error}</div>;
};

export default Error;
